export default "__VITE_ASSET__c5918659__"